{
  "nl": {
    "sharedLibrary": {
      "title": "Gedeelde Opslag",
      "subline": "Hier stelt jullie team sjablonen voor de dagelijkse schoolpraktijk beschikbaar – alleen zichtbaar voor jullie school.\nKopieer wat je nodig hebt en voeg toe wat anderen helpt.",
      "tutorial": "Bekijk de tutorial",
      "badge": {
        "schoolLicenseOnly": "Alleen met fobizz Schoollicentie"
      },
      "licenseTeaser": {
        "title": "De materiaalkast van jouw school",
        "text": "Hier stelt jullie team sjablonen voor de dagelijkse schoolpraktijk beschikbaar – alleen zichtbaar voor jullie school. Kopieer wat je nodig hebt en voeg toe wat anderen helpt.",
        "hasLicense": {
          "question": "Heeft jouw instelling al een licentie?",
          "placeholder": "Voer de code van de schoollicentie in…",
          "success": "Schoollicentie geactiveerd! Je bent nu lid van „{groupTitle}“."
        },
        "noLicense": {
          "question": "Heeft jouw instelling nog geen licentie?",
          "requestLink": "Aanvragen voor mijn school",
          "requestUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/"
        }
      },
      "createMenu": {
        "hint": "AI-Assistenten en multimediatoepassingen kun je alleen vanuit je opslag hier naartoe kopiëren.",
        "createNew": "Nieuw maken",
        "importFromMyContent": "Kopiëren uit Mijn Opslag"
      },
      "importDialog": {
        "title": "Kopiëren uit Mijn Opslag",
        "tabLabel": "Mijn Opslag",
        "searchPlaceholder": "Zoekterm…",
        "confirm": "Kopiëren",
        "empty": "Geen inhoud gevonden.",
        "emptyFolder": "Deze map is leeg.",
        "errorLoading": "Je inhoud kon niet worden geladen."
      },
      "search": {
        "placeholder": "Doorzoek gedeelde opslag..."
      },
      "actions": {
        "copyToMyContent": "Kopiëren naar Mijn Opslag",
        "copyToMyContentPending": "Wordt gekopieerd naar Mijn Opslag …",
        "copyToSharedLibrary": "Kopiëren naar Gedeelde Opslag",
        "copyToSharedLibraryDescription": "(Origineel blijft ongewijzigd)",
        "copyFolderNotSupported": "Nog niet mogelijk voor mappen"
      },
      "folderNotSupported": {
        "title": "Mappen kunnen nog niet naar de gedeelde opslag worden gekopieerd",
        "selectionHint": "Selecteer de inhoud in de map en kopieer deze afzonderlijk of samen."
      },
      "copyDialog": {
        "title": "Kopiëren naar Gedeelde Opslag",
        "school": "School",
        "folder": "Map",
        "createFolder": "Nieuwe map aanmaken",
        "newFolderName": "Naam van de nieuwe map",
        "folderLoadError": "De mappen konden niet worden geladen. Probeer het opnieuw."
      },
      "moveDialog": {
        "mixedSelection": "De geselecteerde inhoud bevindt zich in verschillende opslagruimtes. Verplaatsen is alleen mogelijk binnen één opslagruimte – selecteer inhoud uit slechts één opslagruimte."
      },
      "copyResult": {
        "success": "Inhoud is succesvol gekopieerd naar de Gedeelde Opslag",
        "failure": "Je selectie kon niet worden gekopieerd naar de Gedeelde Opslag",
        "retry": "Probeer het opnieuw.",
        "responsesNotCopied": "De inzendingen van je leerlingen worden niet gekopieerd."
      },
      "adoptDialog": {
        "title": "Kopiëren naar Mijn Opslag",
        "folder": "Map"
      },
      "adoptResult": {
        "success": "Inhoud is succesvol gekopieerd naar Mijn Opslag",
        "failure": "Je selectie kon niet worden gekopieerd naar Mijn Opslag"
      },
      "schoolSelect": {
        "ariaLabel": "School wisselen",
        "hint": "Hier kun je je school selecteren"
      },
      "links": {
        "backToLibrary": "Naar Gedeelde Opslag",
        "trash": "Prullenbak bekijken"
      },
      "emptyState": {
        "root": "Er is nog geen inhoud in de Gedeelde Opslag van jouw school.",
        "folder": "Er is momenteel geen inhoud in deze map."
      },
      "noAccess": {
        "noSchool": {
          "title": "Je behoort nog tot geen enkele school",
          "text": "De Gedeelde Opslag hoort altijd bij een school. Zodra je aan een school bent toegewezen, vind je hier de materialen van jullie team."
        },
        "disabledBySchool": {
          "title": "Jouw school heeft de Gedeelde Opslag gedeactiveerd",
          "text": "Voor jouw school is de Gedeelde Opslag uitgeschakeld. Neem contact op met het licentiebeheer van jouw school als jullie deze weer willen gebruiken."
        },
        "refusedBySchool": {
          "title": "Deze Gedeelde Opslag is niet meer voor je toegankelijk",
          "text": "Jouw school geeft deze Gedeelde Opslag momenteel niet voor je vrij. Dit gebeurt wanneer je lidmaatschap is beëindigd of wanneer jouw school de Gedeelde Opslag heeft gedeactiveerd. Laad de pagina opnieuw of neem contact op met het licentiebeheer van jouw school."
        }
      },
      "copySelectionDialog": {
        "title": "Selectie kopiëren naar Gedeelde Opslag",
        "school": "School",
        "createFolder": "Nieuwe map aanmaken",
        "newFolderName": "Naam van de nieuwe map"
      },
      "trash": {
        "heading": "Prullenbak",
        "buttons": {
          "clear": "Prullenbak legen"
        },
        "emptyTable": "Er zijn momenteel geen verwijderde items in de Gedeelde Opslag van jouw school.",
        "subline": "Verwijderde materialen en mappen blijven <strong>30 dagen</strong> in de prullenbak. Tot die tijd kunnen ze worden hersteld, daarna worden ze definitief verwijderd."
      },
      "preview": {
        "loadError": "De inhoud kon niet worden geladen.",
        "noTask": "Er is geen werkopdracht opgeslagen.",
        "noWords": "Er zijn nog geen woorden ingevoerd.",
        "qrCodeAlt": "QR-code voor {url}",
        "targetUrl": "Doel-URL",
        "type": "Type"
      }
    }
  }
}
